import { render, staticRenderFns } from "./FamilyDrawer.vue?vue&type=template&id=4bb97f3a&scoped=true"
import script from "./FamilyDrawer.vue?vue&type=script&lang=js"
export * from "./FamilyDrawer.vue?vue&type=script&lang=js"
import style0 from "./FamilyDrawer.vue?vue&type=style&index=0&id=4bb97f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb97f3a",
  null
  
)

export default component.exports